import {Actions} from '@redstack/shared'
import {createFileRoute} from '@tanstack/react-router'
import {UsersPage} from '@/features/users/UsersPage'
import {useRequirePermission} from '@/hooks/useRequirePermission'

function UsersRoute() {
	if (!useRequirePermission(Actions.USERS_MANAGE)) return null
	return <UsersPage />
}

export const Route = createFileRoute('/users/')({
	component: UsersRoute,
})
